module.exports = __webpack_public_path__ + "static/media/no-fuel-use.06949fa2.svg";